// =======================
// Stable Swiper + Variant + Zoom (Buddy😎 Final Edition)
// - Same structure preserved
// - All functionalities active
// - Optimized for Shopify
// =======================

(function () {
    "use strict";

    function syncMainThumbnails(activeIndex) {
        const thumbs = document.querySelectorAll(
            ".product__media-sublist img, .product__media-thumbnail"
        );

        thumbs.forEach((thumb, i) => {
            thumb.classList.toggle("is-active", i === activeIndex);
        });
    }

    const swiperByEl = new WeakMap();
    let lastIsMobile = null;
    let resizeTimer;
    let variantTimer;
    let lastSwatchValue = null;

    let kymee_lastActiveSlide = 0; // 🔧 FIX: remember last active swiper slide

    function logVideoDebug(eventName, payload = {}) {
        if (!window.__KYMEE_VIDEO_DEBUG__) return;
        console.log("[KYMEE PDP VIDEO]", eventName, payload);
    }

    function isVisibleForAutoplay(element) {
        if (!element || !element.isConnected) return false;

        const styles = window.getComputedStyle(element);
        if (styles.display === "none" || styles.visibility === "hidden") return false;

        const rect = element.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0;
    }

    function observeProductMedia() {
        const observer = new MutationObserver(() => {
            const swiperEl = document.querySelector(".product-media-swiper");

            if (!swiperEl || swiperByEl.has(swiperEl) || swiperEl.classList.contains("swiper-initialized")) {
                return;
            }

            if (swiperEl.querySelector(".swiper-wrapper")) {
                initAllSwipers(true);
                observer.disconnect(); // ✅ run only once
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }


    // =========================================
    // 🚫 DISABLE SHOPIFY MEDIA-GALLERY SYNC
    // =========================================
    function disableShopifyMediaSync() {
        const mg = document.querySelector("media-gallery");
        if (!mg) return;

        mg.removeAttribute("deferred-media");
        mg.setAttribute("data-disable-media-sync", "true");

        // Stop Shopify from forcing active image change
        mg.setActiveMedia = function () { };
        mg.scrollIntoView = function () { };
    }

    function getSelectedVariant() {
        const fieldsets = document.querySelectorAll("fieldset");
        const selectedValues = Array.from(fieldsets)
            .map((fs) => fs.querySelector("input:checked"))
            .filter(Boolean)
            .map((input) => input.value);

        const selectedVariantTitle = [...new Set(selectedValues)].join(" / ");
        if (!selectedVariantTitle || typeof p_variants === "undefined") return null;

        return p_variants.find((variant) => variant.title === selectedVariantTitle) || null;
    }

    function getPreferredVideoSources(sources = []) {
        const playableSources = sources.filter((source) => source?.mime_type?.includes("video"));
        const mp4Sources = playableSources.filter((source) => source.mime_type === "video/mp4");
        return mp4Sources.length ? mp4Sources : playableSources;
    }

    function forceVideoPlayback(video, context = {}) {
        if (!video || !video.isConnected) return;

        const contextLabel = {
            mediaId: video.dataset.productMediaId || video.closest("[data-media-id]")?.dataset.mediaId || null,
            reason: context.reason || "direct-play",
            retry: Boolean(context.retry),
        };

        video.autoplay = true;
        video.defaultMuted = true;
        video.muted = true;
        video.playsInline = true;
        video.setAttribute("autoplay", "");
        video.setAttribute("defaultmuted", "");
        video.setAttribute("muted", "");
        video.setAttribute("playsinline", "");
        video.setAttribute("webkit-playsinline", "");
        if (video.hasAttribute("loop")) {
            video.loop = true;
        }

        const tryPlay = () => {
            logVideoDebug("play-attempt", {
                ...contextLabel,
                currentSrc: video.currentSrc || video.querySelector("source")?.src || null,
                readyState: video.readyState,
                paused: video.paused,
                visible: isVisibleForAutoplay(video),
            });

            const playPromise = video.play();
            if (playPromise && typeof playPromise.then === "function") {
                playPromise
                    .then(() => {
                        logVideoDebug("play-resolved", {
                            ...contextLabel,
                            currentTime: video.currentTime,
                        });
                    })
                    .catch((error) => {
                        logVideoDebug("play-rejected", {
                            ...contextLabel,
                            name: error?.name || "UnknownError",
                            message: error?.message || "",
                            visible: isVisibleForAutoplay(video),
                            readyState: video.readyState,
                        });

                        if (!context.retry) {
                            window.setTimeout(() => {
                                forceVideoPlayback(video, {
                                    ...context,
                                    retry: true,
                                    reason: `${contextLabel.reason}-retry`,
                                });
                            }, 160);
                        }
                    });
            }
        };

        if (video.readyState < 2) {
            video.load();
            video.addEventListener("canplay", tryPlay, { once: true });
            return;
        }

        tryPlay();
    }

    function autoplayActiveSlideVideo(swiperRoot, swiperInstance, reason = "swiper-active") {
        if (!swiperRoot) return;

        const slides = Array.from(swiperRoot.querySelectorAll(".swiper-slide"));
        if (!slides.length) return;

        const activeSlide =
            slides.find((slide) => slide.classList.contains("swiper-slide-active") && !slide.classList.contains("swiper-slide-duplicate")) ||
            slides[swiperInstance?.activeIndex || 0] ||
            null;

        const activeVideo = activeSlide?.querySelector("video");

        swiperRoot.querySelectorAll("video").forEach((video) => {
            if (video !== activeVideo) {
                video.pause();
                video.currentTime = 0;
            }
        });

        if (!activeVideo) {
            logVideoDebug("no-active-video", {
                reason,
                activeIndex: swiperInstance?.activeIndex ?? null,
            });
            return;
        }

        const playWhenVisible = () => {
            if (!isVisibleForAutoplay(activeVideo)) {
                window.setTimeout(() => playWhenVisible(), 80);
                return;
            }

            forceVideoPlayback(activeVideo, {
                reason,
                mediaId: activeVideo.dataset.productMediaId || activeSlide?.dataset.mediaId || null,
            });
        };

        requestAnimationFrame(playWhenVisible);
    }

    function syncProductMediaVideos(root = document) {
        if (!root) return;

        root.querySelectorAll(".product-media-swiper").forEach((swiperRoot) => {
            autoplayActiveSlideVideo(swiperRoot, swiperByEl.get(swiperRoot), "sync-root");
        });

        root.querySelectorAll(".product__media-list video, .product__media video").forEach((video) => {
            if (video.closest(".product-media-swiper")) return;
            if (video.offsetParent === null) return;
            forceVideoPlayback(video, { reason: "non-swiper-sync" });
        });
    }

    function shouldSyncMediaOnLoad() {
        const selectedVariant = getSelectedVariant();
        if (!selectedVariant || typeof p_variants === "undefined" || !p_variants.length) {
            return false;
        }

        return selectedVariant.id !== p_variants[0].id;
    }

    // -----------------------------
    // 🌀 SWIPER (MOBILE ONLY)
    // -----------------------------
    function destroySwiper(el) {
        const inst = swiperByEl.get(el);

        if (inst) {
            kymee_lastActiveSlide = inst.activeIndex || 0;
            inst.destroy(true, true);
        }

        el.classList.remove("swiper-initialized"); // optional safety
        swiperByEl.delete(el);
    }



    function initSwiper(el) {
        if (!el) return;

        if (!el.classList.contains("swiper")) el.classList.add("swiper");

        let pag = el.querySelector(".mobile-product-media-pagination");
        if (!pag) {
            pag = document.createElement("div");
            pag.className = "mobile-product-media-pagination";
            el.appendChild(pag);
        }

        if (!document.getElementById("swiper-pagination-styles")) {
            const style = document.createElement("style");
            style.id = "swiper-pagination-styles";
            style.textContent = `
        .mobile-product-media-pagination{position:absolute;display:flex;justify-content:center;align-items:center;margin-top:15px;padding:8px 0;gap:6px;z-index:10}
        .swiper-pagination-bullet{width:4px;height:4px;border-radius:50%;background:rgba(0,0,0,.2);margin:0!important;transition:all .3s cubic-bezier(.4,0,.2,1);cursor:pointer;border:none;outline:none;padding:0;opacity:.6}
        .swiper-pagination-bullet-active{width:20px;height:6px;border-radius:9999px;background:#000;opacity:1}
        .swiper-pagination-bullet.is-near-1{width:8px;height:8px;opacity:.8}
        .swiper-pagination-bullet.is-near-2{width:6px;height:6px;opacity:.7}
        .swiper-pagination-bullet:hover{opacity:1;transform:scale(1.1)}
        .swiper-pagination-bullet-active:hover{transform:none}`;
            document.head.appendChild(style);
        }

        const inst = new Swiper(el, {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 10,
            observer: true,
            observeParents: true,
            resizeObserver: true,
            speed: 300,
            pagination: {
                el: pag,
                clickable: true,
                type: "bullets",
                bulletClass: "swiper-pagination-bullet",
                bulletActiveClass: "swiper-pagination-bullet-active",
                renderBullet(index, className) {
                    return `<span class="${className}" data-index="${index}"></span>`;
                },
            },
            on: {
                init() {

                    // ✅ RESTORE LAST ACTIVE SLIDE (🔥 FIX)
                    if (
                        typeof kymee_lastActiveSlide === "number" &&
                        kymee_lastActiveSlide > 0 &&
                        kymee_lastActiveSlide < this.slides.length
                    ) {
                        this.slideTo(kymee_lastActiveSlide, 0, false);
                    }

                    // show swiper AFTER correct slide is set
                    el.classList.remove("swiper--pending");
                    el.style.opacity = "1";
                    el.style.visibility = "visible";

                    this.updatePaginationClasses = () => {
                        const bullets = Array.from(this.pagination.bullets || []);
                        const activeIndex = this.activeIndex;
                        bullets.forEach((b, i) => {
                            const dist = Math.abs(i - activeIndex);
                            b.classList.toggle("is-near-1", dist === 1);
                            b.classList.toggle("is-near-2", dist === 2);
                        });
                    };

                    this.updatePaginationClasses();

                    setTimeout(() => {
                        initCustomZoom(el);
                    }, 0);

                    requestAnimationFrame(() => {
                        autoplayActiveSlideVideo(el, this, "swiper-init");
                    });
                },
                slideChange() {
                    kymee_lastActiveSlide = this.activeIndex; // 🔥 VERY IMPORTANT
                    if (this.updatePaginationClasses) this.updatePaginationClasses();
                    syncMainThumbnails(this.activeIndex);
                },
                slideChangeTransitionEnd() {
                    autoplayActiveSlideVideo(el, this, "slide-change-end");
                },
            },

        });

        autoplayActiveSlideVideo(el, inst, "swiper-init-post-create");

        swiperByEl.set(el, inst);
    }

    function initAllSwipers(force = false) {
        disableShopifyMediaSync();
        const isMobile = window.matchMedia("(max-width: 789px)").matches;
        if (!force && lastIsMobile === isMobile) return;

        document.querySelectorAll(".product-media-swiper").forEach((el) => {
            if (!el.isConnected) return;
            if (isMobile) {
                if (swiperByEl.has(el)) destroySwiper(el);
                initSwiper(el);
            } else {
                destroySwiper(el);
            }
        });

        lastIsMobile = isMobile;
    }

    // -----------------------------
    // 🧬 VARIANT CHANGE HANDLER
    // -----------------------------
    function processVariantCustom() {
        const infoWrapper = document.querySelector(".product__info-wrapper");
        if (!infoWrapper) return;

        // const swatch = document.querySelector('.product__info-wrapper .swatch-input__input:checked');
        // const currentSwatch = swatch ? swatch.value : null;


        /* -----------------------------------------
       👉 Only change IMAGES if COLOR changed
    ----------------------------------------- */
        // const shouldUpdateImages = currentSwatch !== lastSwatchValue;

        //console.warn("Should update images:", shouldUpdateImages);

        // Update tracker
        // lastSwatchValue = currentSwatch;

        const variant = getSelectedVariant();
        if (!variant) return;

        const wishlistBtn = infoWrapper.querySelector(".wishlist_button");

        if (wishlistBtn) {
            wishlistBtn.setAttribute("data-product-variant-id", variant.id);
            wishlistBtn.setAttribute("data-selected-variant-value", variant.option1);
        }

        document
            .querySelectorAll(".stock-label, .estimated-delivery")
            .forEach((e) => (e.style.display = "none"));
        document
            .querySelector(`.stock-label[data-variant-id="${variant.id}"]`)
            ?.style.setProperty("display", "flex");
        document
            .querySelector(`.estimated-delivery[data-variant-id="${variant.id}"]`)
            ?.style.setProperty("display", "block");
        // const priceEl = document.querySelector("#buy-now-price");
        // if (variant.compareAtPriceBuyNow > variant.priceBuyNow) {
        //     priceEl.innerHTML = variant.priceBuyNow;
        // }
        // else {
        //     priceEl.innerHTML = variant.priceBuyNow;
        // }

        // if (!shouldUpdateImages) {
        //     return;
        // }

        const grid = document.querySelector(".product__media-list");
        const mediaGallery = document.querySelector("media-gallery");
        if (!grid && !mediaGallery) return;

        // Variant image rebuild logic
        if (variant.variant_image?.length) {
            const gridRef = grid || mediaGallery;
            // gridRef.style.opacity = 0;

            setTimeout(() => {
                let html = "";
                if (window.innerWidth <= 749) {
                    html += '<div class="swiper-wrapper">';
                    variant.variant_image.forEach((media, index) => {
                        if (typeof media === "string") {
                            const fetchPriority = index === 0 ? 'fetchpriority="high"' : '';
                            html += `
                <div class="swiper-slide product__media-item grid__item scroll-trigger animate--fade-in" role="group" aria-label="1 / 3" style="width: 345px; margin-right: 10px;">
          

                                        <div class="product-media-container media-type-image media-fit-cover global-media-settings gradient constrain-height" style="--ratio: 1.0; --preview-ratio: 1.0;">
                                        <modal-opener class="product__modal-opener product__modal-opener--image" data-modal="#ProductModal-template--25018520174871__main">

                                        <div class="loading__spinner hidden">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>

                                        </div>
                                        <div class="product__media media media--transparent">
                                            <img src="${media}" alt="" ${fetchPriority} srcset="${media.replace(/width=\d+/g, 'width=246')} 246w, ${media.replace(/width=\d+/g, 'width=493')} 493w, ${media.replace(/width=\d+/g, 'width=600')} 600w, ${media.replace(/width=\d+/g, 'width=713')} 713w, ${media.replace(/width=\d+/g, 'width=823')} 823w, ${media.replace(/width=\d+/g, 'width=990')} 990w, ${media.replace(/width=\d+/g, 'width=1100')} 1100w, ${media.replace(/width=\d+/g, 'width=1206')} 1206w, ${media.replace(/width=\d+/g, 'width=1346')} 1346w, ${media.replace(/width=\d+/g, 'width=1426')} 1426w, ${media.replace(/width=\d+/g, 'width=1646')} 1646w, ${media.replace(/width=\d+/g, 'width=1946')} 1946w" width="1946" height="2433" loading="lazy" class="image-magnify-hover" sizes="(min-width: 1200px) 715px, (min-width: 990px) calc(65.0vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw / 1 - 4rem)">
                                            </div>
                                        </modal-opener></div>

                                                </div>`;
                        }
                        if (media.media_type === "video" && media.sources) {
                            html += `<div class="swiper-slide product__media-item grid__item scroll-trigger animate--fade-in" role="group" aria-label="1 / 3" style="width: 345px; margin-right: 10px;"><div class="product-media-container media-type-video media-fit-cover global-media-settings gradient constrain-height" style="--ratio: 1.0; --preview-ratio: 1.0;">
                                        <div class="product__media media media--transparent">
                                        <deferred-media><video class="pdp_video" data-product-media-id="${media.id || ""}" autoplay loop muted defaultmuted playsinline webkit-playsinline preload="auto" style="aspect-ratio: 1.0; object-fit: cover; width: 100%; height: 100%;">`;
                            getPreferredVideoSources(media.sources).forEach((source) => {
                                html += `<source src="${source.url}" type="${source.mime_type}">`;
                            });
                            html += `Your browser does not support the video tag.</video></deferred-media></div></div></div>`;
                        }
                    });
                    html += "</div>";
                    mediaGallery.innerHTML = `<div class="product-media-swiper swiper swiper--pending only-mobile">${html}</div>`;
                    setTimeout(() => {
                        initAllSwipers(true);
                        const container = document.querySelector(".product-media-swiper");
                        syncProductMediaVideos(mediaGallery);
                        if (typeof enableZoomOnHover === "function") enableZoomOnHover(2);
                        // if (container) initCustomZoom(container);
                    }, 100);
                } else {
                    variant.variant_image.forEach((media, index) => {
                        if (typeof media === "string") {
                            const fetchPriority = index === 0 ? 'fetchpriority="high"' : '';
                            html += `
                      <li class="product__media-item grid__item slider__slide scroll-trigger animate--fade-in" 
                            data-media-id="template--25018520174871__main-40888521785623">

                            <div class="product-media-container media-type-image media-fit-fill global-media-settings gradient constrain-height" style="--ratio: 1; --preview-ratio: 1;">
                            <modal-opener class="product__modal-opener product__modal-opener--image" data-modal="#ProductModal-template--25018520174871__main">
                                

                            <div class="loading__spinner hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>

                            </div>
                            <div class="product__media media media--transparent">
                                <img src="${media}?width=1946" alt="" ${fetchPriority} srcset="${media}?width=246 246w, ${media}?width=493 493w, ${media}?width=600 600w, ${media}?width=713 713w, ${media}?width=823 823w, ${media}?width=990 990w, ${media}?width=1100 1100w, ${media}?width=1206 1206w, ${media}?width=1346 1346w, ${media}?width=1426 1426w, ${media}?width=1646 1646w, ${media}?width=1946 1946w" width="1946" height="2433" loading="lazy" class="image-magnify-hover" sizes="(min-width: 1200px) 715px, (min-width: 990px) calc(65.0vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw / 1 - 4rem)">
                                </div>
                            </modal-opener></div>

                                    </li>
                      `;
                        } else if (media.media_type === "video" && media.sources) {
                            html += `<li class="product__media-item grid__item slider__slide scroll-trigger animate--fade-in"><div class="product-media-container media-type-video media-fit-cover global-media-settings gradient constrain-height" style="--ratio: 1; --preview-ratio: 1;"><deferred-media><video class="pdp_video" data-product-media-id="${media.id || ""}" autoplay loop muted defaultmuted playsinline webkit-playsinline preload="auto" style="aspect-ratio: 1;object-fit: cover;width: 100%;height: 100%;float: left;">`;
                            getPreferredVideoSources(media.sources).forEach((source) => {
                                html += `<source src="${source.url}" type="${source.mime_type}">`;
                            });
                            html += `</video></deferred-media></div></li>`;
                        }
                    });
                    grid.innerHTML = html;
                    syncProductMediaVideos(grid);
                    if (typeof enableZoomOnHover === "function") enableZoomOnHover(2);
                    // initCustomZoom(grid);
                }
                // gridRef.style.opacity = 1;
            }, 500);
        }
    }

    // -----------------------------
    // 🔍 CUSTOM ZOOM
    // -----------------------------
    class CustomZoom {
        constructor() {
            this.dialog = null;
            this.media = [];
            this.currentIndex = 0;
            this.setup();
        }

        disableParentScroll() {
            this._slideLocked = true;
        }
        enableParentScroll() {
            this._slideLocked = false;
        }



        setup() {
            if (document.getElementById("custom-zoom-dialog")) {
                this.dialog = document.getElementById("custom-zoom-dialog");
                this.thumbs = this.dialog.querySelector("[ref='thumbnails']");
                this.content = this.dialog.querySelector(
                    ".dialog-zoomed-gallery__content"
                );
                return;
            }

            const html = `
        <div id="custom-zoom-dialog" hidden>
          <button class="close-btn" aria-label="Close">&times;</button>
          <div class="dialog-thumbnails-list" ref="thumbnails"></div>
          <div class="dialog-zoomed-gallery__content"></div>
        </div>`;
            document.body.insertAdjacentHTML("beforeend", html);

            const style = document.createElement("style");
            style.textContent = `
        #custom-zoom-dialog{position:fixed;inset:0;background:rgba(0,0,0,0.9);z-index:1000;display:flex;flex-direction:column;align-items:center;justify-content:center}
        #custom-zoom-dialog[hidden]{display:none!important}
        .close-btn{position:absolute;top:15px;right:15px;background:#000;color:#fff;border:none;font-size:24px;cursor:pointer;z-index:1;}
        .dialog-thumbnails-list{position: fixed;bottom: 10px;width: 100%;overflow: auto;left: 0;padding: 10px;display:flex;gap:6px;margin-top:10px;overflow-x:auto;scrollbar-width:none;-ms-overflow-style: none;}
        .dialog-thumbnails-list img{width:60px;height:60px;object-fit:cover;cursor:pointer;opacity:.6;border:2px solid transparent;border-radius:6px;flex: 0 0 60px}
        .dialog-thumbnails-list img.active{opacity:1;border-color:#fff}.dialog-zoomed-gallery__content video{max-width:100%}
        .dialog-zoomed-gallery__content{width:100%;height:auto;display:flex;flex-direction:row;align-items: center}
        .dialog-zoomed-gallery__content > img, .dialog-zoomed-gallery__content > video{flex: 0 0 100%;}
        .dialog-zoomed-gallery__content > video{height: 60vh;object-fit: cover;}
        .dialog-zoomed-gallery__content img{max-width:100%;max-height:auto;object-fit:contain;animation:fadeIn .3s ease}
        .dialog-zoomed-gallery__content::-webkit-scrollbar, .dialog-thumbnails-list::-webkit-scrollbar{height: 0;width: 0;display: none;}
        .zoomable-media {cursor: zoom-in; transition: transform 0.25s ease; transform-origin: center center;}
        .zoomable-media.is-zoomed {cursor: grab;}
        .zoom-slide {
 flex: 0 0 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.zoom-pan-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.zoomable-media {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  transform-origin: center center;
  transition: transform 0.25s ease;
  cursor: zoom-in;
}

.zoomable-media.is-zoomed {
  cursor: grab;
}
 .zoom-pan-wrapper { touch-action: pan-x pan-y pinch-zoom; }

.zoomable-media { touch-action: pan-x; }

.zoomable-media.is-zoomed { touch-action: none; }


        @keyframes fadeIn{from{opacity:0}to{opacity:1}}`;
            document.head.appendChild(style);

            this.dialog = document.getElementById("custom-zoom-dialog");
            this.thumbs = this.dialog.querySelector("[ref='thumbnails']");
            this.content = this.dialog.querySelector(".dialog-zoomed-gallery__content");

            this.dialog.querySelector(".close-btn").addEventListener("click", () => this.close());
            this.dialog.addEventListener("click", (e) => {
                if (e.target === this.dialog) this.close();
            });
        }

        open(index, mediaArr) {
            this.media = mediaArr;
            this.currentIndex = index;

            this._opening = true;
            this._ignoreScrollSync = true;

            this.dialog.hidden = false;
            document.body.style.overflow = "hidden";

            // 👇 pass flag
            this.updateDialog(true);

            setTimeout(() => {
                this._opening = false;
                this._ignoreScrollSync = false;
            }, 50);
        }



        close() {
            this.dialog.hidden = true;
            document.body.style.overflow = "";
            syncProductMediaVideos(document.querySelector(".product__media-wrapper"));
        }

        updateDialog(isInitialOpen = false) {
            if (!isInitialOpen) return;

            this.content.innerHTML = "";
            this.thumbs.innerHTML = "";

            /* -----------------------------
               🔹 RENDER THUMBNAILS
            ----------------------------- */
            this.media.forEach((m, i) => {
                const thumb = document.createElement("img");
                thumb.src = m.poster || m.src;
                thumb.alt = "";
                thumb.dataset.index = i;

                if (i === this.currentIndex) thumb.classList.add("active");

                thumb.onclick = () => {
                    this.scrollToIndex(i);
                };

                this.thumbs.appendChild(thumb);
            });

            /* -----------------------------
               🔹 RENDER MAIN CONTENT
            ----------------------------- */
            this.media.forEach((m, i) => {
                const slide = document.createElement("div");
                slide.className = "zoom-slide";
                slide.dataset.index = i;

                if (m.type === "image") {
                    const pan = document.createElement("div");
                    pan.className = "zoom-pan-wrapper";

                    const img = document.createElement("img");
                    img.src = m.src;
                    img.className = "zoomable-media";
                    img.dataset.scale = 1;
                    img.dataset.x = 0;
                    img.dataset.y = 0;

                    pan.appendChild(img);
                    slide.appendChild(pan);

                    // ✅ enable zoom ONLY on img
                    this.enableAdvancedZoom(img);

                } else {
                    const video = document.createElement("video");
                    video.src = m.src;
                    video.autoplay = true;
                    video.defaultMuted = true;
                    video.loop = true;
                    video.muted = true;
                    video.controls = true;
                    video.playsInline = true;
                    video.setAttribute("webkit-playsinline", "");
                    video.className = "zoomed-gallery__video";
                    slide.appendChild(video);
                }

                this.content.appendChild(slide);
            });

            /* -----------------------------
               ✅ INSTANT POSITION (NO SCROLL, NO TRAVEL)
            ----------------------------- */
            const target = this.content.querySelector(
                `[data-index="${this.currentIndex}"]`
            );

            if (target) {
                // temporarily disable snap & smooth
                this.content.style.scrollSnapType = "none";
                this.content.style.scrollBehavior = "auto";

                // direct jump
                this.content.style.transition = "none";
                this.content.style.transform = `translateX(-${this.currentIndex * 100}%)`;

                // restore snap behavior
                requestAnimationFrame(() => {
                    this.content.style.transition = "transform 0.35s ease";
                });
            }

            this.setActiveThumb(this.currentIndex);

            /* -----------------------------
               🔁 SCROLL SYNC + SNAP
            ----------------------------- */
            // this.bindScrollSync();
            this.bindSnapScroll();
        }

        enableAdvancedZoom(el) {
            let scale = 1;
            let x = 0;
            let y = 0;
            let startX = 0;
            let startY = 0;
            let startDist = 0;
            let startScale = 1;
            let lastTap = 0;

            const apply = () => {
                const rect = el.getBoundingClientRect();
                const parent = el.parentElement.getBoundingClientRect();

                const maxX = (rect.width - parent.width) / 2;
                const maxY = (rect.height - parent.height) / 2;

                x = Math.max(-maxX, Math.min(x, maxX));
                y = Math.max(-maxY, Math.min(y, maxY));

                el.style.transform = `translate(${x}px, ${y}px) scale(${scale})`;
            };


            const reset = () => {
                scale = 1;
                x = 0;
                y = 0;
                el.classList.remove("is-zoomed");
                this.enableParentScroll();
                apply();
                el.style.transform = "translate(0px, 0px) scale(1)";
            };

            el.addEventListener("touchstart", (e) => {
                // 🔥 DOUBLE TAP
                const now = Date.now();
                if (now - lastTap < 300 && e.touches.length === 1) {
                    if (scale > 1) {
                        reset();
                    } else {
                        scale = 2;
                        el.classList.add("is-zoomed");
                        this.disableParentScroll();
                        apply();
                    }
                    e.preventDefault();
                }
                lastTap = now;

                // PINCH START
                if (e.touches.length === 2) {
                    startDist = Math.hypot(
                        e.touches[0].clientX - e.touches[1].clientX,
                        e.touches[0].clientY - e.touches[1].clientY
                    );
                    startScale = scale;
                    this.disableParentScroll();
                }

                // PAN START
                if (e.touches.length === 1 && scale > 1) {
                    startX = e.touches[0].clientX - x;
                    startY = e.touches[0].clientY - y;
                    this.disableParentScroll();
                }
            });

            el.addEventListener("touchmove", (e) => {
                if (e.touches.length === 2) {
                    e.preventDefault();
                    const dist = Math.hypot(
                        e.touches[0].clientX - e.touches[1].clientX,
                        e.touches[0].clientY - e.touches[1].clientY
                    );
                    scale = Math.min(Math.max(startScale * (dist / startDist), 1), 3);
                    el.classList.toggle("is-zoomed", scale > 1);
                    apply();
                    return;
                }

                if (scale > 1 && e.touches.length === 1) {
                    e.preventDefault();
                    x = e.touches[0].clientX - startX;
                    y = e.touches[0].clientY - startY;
                    apply();
                }
            });

            el.addEventListener("touchend", () => {
                if (scale <= 1) reset();
            });
        }



        // ---------- SCROLL TO CONTENT ----------
        scrollToIndex(index) {
            index = Math.max(0, Math.min(index, this.media.length - 1));
            this.currentIndex = index;

            this.content.style.transition = "transform 0.35s ease";
            this.content.style.transform = `translateX(-${index * 100}%)`;

            this.setActiveThumb(index);
            syncMainThumbnails(index);
        }






        // ---------- SET ACTIVE THUMB ----------
        setActiveThumb(index) {
            this.currentIndex = index;

            this.thumbs.querySelectorAll("img").forEach((img, i) => {
                img.classList.toggle("active", i === index);
            });
        }

        // ---------- SCROLL ↔ THUMB SYNC ----------
        bindScrollSync() {
            if (this._scrollBound) return;
            this._scrollBound = true;

            this.content.addEventListener("scroll", () => {
                if (this._opening || this._ignoreScrollSync) return;
                const items = Array.from(this.content.children);
                const contentLeft = this.content.getBoundingClientRect().left;

                let activeIndex = 0;
                let minDiff = Infinity;

                items.forEach((el, i) => {
                    const diff = Math.abs(el.getBoundingClientRect().left - contentLeft);
                    if (diff < minDiff) {
                        minDiff = diff;
                        activeIndex = i;
                    }
                });

                if (activeIndex !== this.currentIndex) {
                    this.setActiveThumb(activeIndex);

                    // ✅ MAIN PAGE THUMB SYNC
                    syncMainThumbnails(activeIndex);
                }
            });
        }


        bindSnapScroll() {
            if (this._snapBound) return;
            this._snapBound = true;

            /* ---------- TOUCH (MOBILE) ---------- */
            let startX = 0;
            let deltaX = 0;
            let touching = false;
            const TOUCH_THRESHOLD = 60;

            this.content.addEventListener("touchstart", (e) => {
                if (this._slideLocked) return;
                if (this.content.querySelector(".zoomable-media.is-zoomed")) return;
                touching = true;
                startX = e.touches[0].clientX;
                deltaX = 0;
                this.content.style.transition = "none";
            }, { passive: true });

            this.content.addEventListener("touchmove", (e) => {
                if (!touching) return;
                deltaX = e.touches[0].clientX - startX;
            }, { passive: true });

            this.content.addEventListener("touchend", () => {
                if (!touching) return;
                touching = false;

                if (Math.abs(deltaX) < TOUCH_THRESHOLD) {
                    this.scrollToIndex(this.currentIndex);
                    return;
                }

                this.scrollToIndex(
                    deltaX < 0 ? this.currentIndex + 1 : this.currentIndex - 1
                );
            });

            /* ---------- WHEEL (DESKTOP) ---------- */
            let wheelLock = false;

            this.content.addEventListener("wheel", (e) => {
                if (this._slideLocked) return;
                e.preventDefault();
                if (wheelLock) return;
                if (this.content.querySelector(".zoomable-media.is-zoomed")) return;

                wheelLock = true;
                this.scrollToIndex(
                    e.deltaY > 0 || e.deltaX > 0
                        ? this.currentIndex + 1
                        : this.currentIndex - 1
                );

                setTimeout(() => wheelLock = false, 400);
            }, { passive: false });
        }

    }

    const customZoom = new CustomZoom();

    function initCustomZoom(container) {
        if (!container) return;

        // 🔧 FIX: collect IMAGE + VIDEO in same DOM order
        const mediaEls = Array.from(
            container.querySelectorAll(".product__media img, .product__media video")
        );

        const mediaArr = mediaEls.map(el => {
            if (el.tagName === "IMG") {
                const src = el.currentSrc || el.src;
                return {
                    type: "image",
                    src: src,
                    poster: src
                };
            } else {
                return {
                    type: "video",
                    src: el.currentSrc || el.src || el.querySelector("source")?.src || "",
                    poster:
                        el.poster ||
                        el.getAttribute("data-poster") ||
                        el.closest(".product__media")?.querySelector("img")?.currentSrc ||
                        ""
                };
            }
        });


        mediaEls.forEach((el, index) => {
            if (el.tagName === "VIDEO") {
                el.style.cursor = "zoom-in";
                el.onclick = (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    customZoom.open(index, mediaArr);
                };
                return;
            }

            el.style.cursor = "zoom-in";
            el.onclick = () => customZoom.open(index, mediaArr);
        });
    }
    // -----------------------------
    // ⚡ EVENT BINDINGS
    // -----------------------------
    document.addEventListener("DOMContentLoaded", () => {
        disableShopifyMediaSync();
        initAllSwipers(true);
        observeProductMedia();
        if (shouldSyncMediaOnLoad()) {
            processVariantCustom();
        } else {
            syncProductMediaVideos(document.querySelector(".product__media-wrapper"));
        }
    });

    document.addEventListener("change", (e) => {
        if (e.target.matches(".product__info-wrapper fieldset input[type='radio']")) {
            clearTimeout(variantTimer);
            variantTimer = setTimeout(processVariantCustom, 1000);
        }
    });

    window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => initAllSwipers(true), 400);
    });
})();
